var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.loadError
    ? _c(
        "contentBox",
        { attrs: { loading: !_vm.recLoaded } },
        [
          _vm.communityPlan
            ? _c(
                "contentTitle",
                { attrs: { label: "COMMUNITY PLAN", close: "home" } },
                [
                  _c(
                    "h2",
                    { staticClass: "text-white font-weight-light pb-2" },
                    [_vm._v(_vm._s(_vm.communityPlan.name))]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.communityPlan
            ? _c(
                "contentBody",
                [
                  _vm.communityPlan
                    ? _c("contentActions", [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-outline-light btn-sm",
                            class: { active: _vm.shareShown === true },
                            on: { click: _vm.share }
                          },
                          [
                            _c(
                              "i",
                              {
                                staticClass: "material-icons md-18",
                                attrs: { title: "share community plan" }
                              },
                              [_vm._v("share")]
                            ),
                            _vm._v(" \n\t\t\t\tShare\n\t\t\t")
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-outline-light btn-sm",
                            on: { click: _vm.zoomTo }
                          },
                          [
                            _c(
                              "i",
                              {
                                staticClass: "material-icons md-18",
                                attrs: { title: "center map on community plan" }
                              },
                              [_vm._v("place")]
                            ),
                            _vm._v(" \n\t\t\t\tCenter\n\t\t\t")
                          ]
                        ),
                        _vm._v(" "),
                        _vm.isAdmin
                          ? _c(
                              "button",
                              {
                                staticClass: "btn btn-outline-light btn-sm",
                                on: { click: _vm.edit }
                              },
                              [
                                _c(
                                  "i",
                                  {
                                    staticClass: "material-icons md-18",
                                    attrs: { title: "edit community plan" }
                                  },
                                  [_vm._v("edit")]
                                ),
                                _vm._v(" \n\t\t\t\tEdit\n\t\t\t")
                              ]
                            )
                          : _vm._e()
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.shareShown
                    ? _c("share", {
                        attrs: { link: _vm.location },
                        on: { close: _vm.share }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "p-3" }, [
                    _c("div", { staticClass: "category-body" }, [
                      _vm.communityPlan.description !== null
                        ? _c("div", { staticClass: "category" }, [
                            _c("div", { staticClass: "category-title" }, [
                              _vm._v("DESCRIPTION")
                            ]),
                            _vm._v(" "),
                            _vm.descriptionExpanded
                              ? _c("div", { staticClass: "property-row" }, [
                                  _c(
                                    "div",
                                    { staticClass: "text-description" },
                                    [_vm._v(_vm._s(_vm.description))]
                                  ),
                                  _vm._v(" "),
                                  _vm.description !== _vm.descriptionShort
                                    ? _c("div", [
                                        _c(
                                          "a",
                                          {
                                            attrs: { href: "javascript:" },
                                            on: { click: _vm.descriptionLess }
                                          },
                                          [_vm._v("less")]
                                        )
                                      ])
                                    : _vm._e()
                                ])
                              : _c("div", { staticClass: "property-row" }, [
                                  _c(
                                    "div",
                                    { staticClass: "text-description" },
                                    [_vm._v(_vm._s(_vm.descriptionShort))]
                                  ),
                                  _vm._v(" "),
                                  _vm.description !== _vm.descriptionShort
                                    ? _c("div", [
                                        _c(
                                          "a",
                                          {
                                            attrs: { href: "javascript:" },
                                            on: { click: _vm.descriptionMore }
                                          },
                                          [_vm._v("more")]
                                        )
                                      ])
                                    : _vm._e()
                                ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.communityPlan.jurisdiction !== null &&
                      _vm.communityPlan.jurisdiction.name !== null
                        ? _c("div", { staticClass: "category" }, [
                            _c("div", { staticClass: "category-title" }, [
                              _vm._v("JURISDICTION")
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "property-row" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "text-description property-locked"
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.communityPlan.jurisdiction.name)
                                  )
                                ]
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.communityPlan.references
                        ? _c(
                            "div",
                            { staticClass: "category" },
                            [
                              _c("div", { staticClass: "category-title" }, [
                                _vm._v("REFERENCES")
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.communityPlan.references, function(
                                ref,
                                idx
                              ) {
                                return _c(
                                  "div",
                                  { staticClass: "property-row" },
                                  [
                                    _c("label", [
                                      _vm._v(_vm._s(ref.description))
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "property-value-right" },
                                      [
                                        _c(
                                          "a",
                                          {
                                            attrs: {
                                              href: ref.url,
                                              target: "_blank"
                                            }
                                          },
                                          [
                                            _c(
                                              "i",
                                              {
                                                staticClass:
                                                  "material-icons md-12"
                                              },
                                              [_vm._v("open_in_new")]
                                            ),
                                            _vm._v(" Link")
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              })
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.description && !_vm.communityPlan.references
                        ? _c("div", { staticClass: "category" }, [
                            _c("div", { staticClass: "category-title" }, [
                              _vm._v("DETAILS")
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "property-row" }, [
                              _c("div", { staticClass: "text-description" }, [
                                _vm._v(
                                  "No data available for this community plan"
                                )
                              ])
                            ])
                          ])
                        : _vm._e()
                    ])
                  ])
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0a6aeaef", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a6aeaef","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/community-plan/community-plan.vue
// module id = null
// module chunks = 